import React from "react";
import { useIsMobile } from "app/hooks";
import { Icon, ModalDialog } from "@culturehq/components";
import ModalHeader from "./ModalHeader";
import { usePostStoryContext } from "../../contexts/PostStoryContext";

const ModalHeaderToggle: React.FC = () => {
  const isMobile = useIsMobile();
  const { state: { userInformationRequest }, setState, onConfirmClose } = usePostStoryContext();

  const handleBack = () => setState({ userInformationRequest: false });

  if (isMobile) {
    return (
      <div className="mobile-header">
        <div className="mobile-content">
          <Icon
            icon={userInformationRequest ? "chevron-left" : "close"}
            color="rgba(0, 0, 0, .7)"
            onClick={userInformationRequest ? handleBack : onConfirmClose}
          />
          <h4>
            {userInformationRequest ? "Confirm Details" : "Answer Prompt"}
          </h4>
        </div>
        <div className="divider" />
      </div>
    );
  }

  return (
    <ModalDialog.Heading bigCloseIcon onClose={onConfirmClose}>
      <ModalHeader />
    </ModalDialog.Heading>
  );
};

export default ModalHeaderToggle;
